import React, { useEffect, useState } from 'react';
import ReactPiwik from 'react-piwik';
import { useSelector } from 'react-redux';
import { flattenToAppURL, getBaseUrl } from '@plone/volto/helpers';

const _piwik = {};
const doWithPiwik = (fn) => {
  if (__SERVER__) return;
  if (!_piwik.instance) {
    const piwikURL =
      //'https://statisticheweb.regione.emilia-romagna.it/analytics/';
      process.env.RAZZLE_PIWIK_URL || window.env.RAZZLE_PIWIK_URL;
    const siteId =
      //parita=19
      process.env.RAZZLE_PIWIK_SITE_ID || window.env.RAZZLE_PIWIK_SITE_ID;
    const jsFilename = //piwik.js
      process.env.RAZZLE_PIWIK_JSFILE || window.env.RAZZLE_PIWIK_JSFILE;
    const phpFilename = //piwik.php
      process.env.RAZZLE_PIWIK_PHPFILE || window.env.RAZZLE_PIWIK_PHPFILE;
    const trackAtConnect = true;

    // const excludedLocations = [
    //   'applicazioni.regione.emilia-romagna.it',
    //   'applicazionitest.regione.emilia-romagna.it',
    //   'test-iocomune-iam.regione.emilia-romagna.it',
    //   'test-iocomune-cm.regione.emilia-romagna.it',
    //   'iocomune-iam.regione.emilia-romagna.it',
    //   'test-www.regione.emilia-romagna.it',
    //   'localhost',
    //   '//10.',
    // ];

    // const enabled =
    //   excludedLocations.filter((f) => window.location.href.indexOf(f) >= 0)
    //     .length === 0;

    if (piwikURL && siteId /*&& enabled*/) {
      _piwik.instance = new ReactPiwik({
        url: piwikURL,
        siteId: siteId,
        jsFilename: jsFilename,
        phpFilename: phpFilename,
      });
    }
  }
  if (_piwik.instance) fn(_piwik.instance);
};

const Matomo = (props) => {
  const { location, content } = props;
  const [lastTrackedUrl, setLastTrackedUrl] = useState(null);

  const title = content?.title;
  const pathname = location.pathname.replace(/\/$/, '');
  const query = location?.search ?? '';

  const contentURL = flattenToAppURL(content?.['@id'] || '');
  const baseUrl = getBaseUrl(pathname) || '';
  const __content = useSelector((state) => state.content);
  const __search = useSelector((state) => state.rer_search);

  useEffect(() => {
    const url = pathname + query;
    let referrer =
      (document.referrer?.length > 0 ? document.referrer : lastTrackedUrl) ??
      '';

    if (!referrer.startsWith('http')) {
      referrer = window?.location?.origin + referrer;
    }

    const isContent = contentURL === pathname;
    const isStaticRoute = baseUrl !== pathname; //for example /search
    const is404 =
      (contentURL ?? '').length === 0 && __content?.get?.error?.status == 404;

    const isSearch = isStaticRoute && pathname.indexOf('/search') >= 0;
    const search_resultsCount = !__search?.loadingResults
      ? __search?.result?.items_total
      : null;

    const trackThisUrl = url != lastTrackedUrl;

    if (
      trackThisUrl &&
      (isContent ||
        is404 ||
        (isStaticRoute && !isSearch) ||
        (isStaticRoute && isSearch && search_resultsCount != null))
    ) {
      doWithPiwik((p) => {
        setLastTrackedUrl(url); //to avoid initial double url tracking

        //TRACK WITH PIWIK
        ReactPiwik.push(['enableLinkTracking']);
        ReactPiwik.push(['setCustomUrl', `${url}`]);
        ReactPiwik.push(['setReferrerUrl', referrer]);
        ReactPiwik.push(['deleteCustomVariables', 'page']);

        if (is404) {
          //traking per pagine 404
          ReactPiwik.push([
            'setDocumentTitle',
            '404 URL: ' +
              encodeURIComponent(url) +
              ' FROM: ' +
              encodeURIComponent(referrer),
          ]);
        } else {
          //tracking per tutte le pagine tranne 404...
          ReactPiwik.push(['setDocumentTitle', title]);
        }

        if (isSearch) {
          //tracking delle pagine dei riusultati della ricerca
          const queryParams = new URLSearchParams(query);
          const search_keyword = queryParams.get('SearchableText');
          const search_category = undefined;
          if (search_keyword && search_keyword != 'null') {
            ReactPiwik.push([
              'trackSiteSearch',
              search_keyword,
              search_category,
              search_resultsCount,
            ]);
          }
        } else {
          //tracking di tutti gli altri tipi di pagina
          ReactPiwik.push(['trackPageView']);
        }
      });
    }
  }, [location.pathname, content, query, __search]);

  return <></>;
};

export default Matomo;
